/**
 * Schedules-tab landing query: every `:Compute` that owns at least one
 * `:ScheduleProfile` or `:Holiday`, plus the per-gateway counts the
 * tile grid renders.
 *
 * The live "is-active" pull is intentionally a separate route
 * (`getActiveSchedules` → `POST /api/ontology/schedules/active`) so
 * this snapshot can be cached with the usual `Plant` tag while the
 * active pull polls.
 *
 * Drained client-side via `drainCypherRows` so plants with many
 * gateways are not clipped at one page.
 */
export const PLANT_SCHEDULE_GATEWAYS_CYPHER = `
            MATCH (c:Compute)
            OPTIONAL MATCH (sp:ScheduleProfile)
              WHERE sp.id STARTS WITH c.id + '/schedule:'
            WITH c, count(distinct sp) AS scheduleProfileCount
            OPTIONAL MATCH (h:Holiday)
              WHERE h.id STARTS WITH c.id + '/holiday:'
            WITH c, scheduleProfileCount, count(distinct h) AS holidayCount
            WHERE scheduleProfileCount > 0 OR holidayCount > 0
            RETURN c, scheduleProfileCount, holidayCount
            ORDER BY toLower(coalesce(c.name, c.id))
            SKIP toInteger($skip) LIMIT toInteger($pageSize)
          `
